import React from 'react'

type Props = {
    left: number,
    bottom: number,
    height: number,
    width: number,
    rotate: number
}

function Batton(props : Props) {
    const size = 0.6 * props.width;
    return (
        <>
            <div className="batton" style=
                {{
                    left: `${props.left - (props.width / 2)}px`,
                    bottom: `${props.bottom}px`,
                    height: `${props.height}px`,
                    width: `${props.width}px`,
                    transform: `rotate(${props.rotate}deg)`,
                }}>
            </div>
            <div className="battonCircle" style=
                {{
                    left: `${props.left - (size / 2) + 0.1 * size}px`,
                    bottom: `${props.bottom - (1.15 * props.height) + 0.1 * size}px`,
                    height: `${0.7 * size}px`,
                    width: `${0.7 * size}px`,
                }}>
            </div>
        </>
    );
}

export default Batton
